import { forwardRef, createElement } from 'react';
import { Trans } from 'react-i18next';
import { useTranslation } from '../hooks.mjs';

const Translation = forwardRef((props, ref) => {
  const { tKey, tOptions, elementType = "span", ...elementProps } = props;
  const { t } = useTranslation();
  return createElement(
    elementType,
    { ...elementProps, "data-lokalise": true, "data-key": tKey, ref },
    /**
     * FIXME: @flexteam/date 패키지에 jsx 플래그를 주지 않기 위해 jsx 사용하지 않음
     * 이미 사실상 date 패키지에 react 의존성이 들어간 형태인데, 옳은 방향이 아닌 것 같음
     * i18n이 date를 의존하는 형태로 수정이 필요할 가능성 있음
     */
    createElement(Trans, {
      ns: "translation",
      i18nKey: tKey,
      t,
      ...tOptions
    })
  );
});

export { Translation as default };
//# sourceMappingURL=index.mjs.map
